import { SessionService } from '../session.service';

const PLACEHOLDER = 'ANONYM';

export class CountlyService {
  public defaultTrackings: any = [
    ['track_pageview', ['/ordersnproduct/app/open/*']],
    ['track_clicks'],
    ['track_errors'],
    ['track_links'],
    ['track_forms'],
    ['collect_from_forms'],
  ];

  public Countly: any;
  public googleDataLayer: any;
  constructor(private sessionService: SessionService) {
    this.Countly = (window as any).Countly;
    // this add the support for google analytics as described in its documents
    // beware that both countly and google analytics must run simultaneously
    this.googleDataLayer = (window as any).dataLayer || [];
  }

  public init() {
    if (this.Countly !== undefined) {
      this.addTracking('track_sessions');
      this.Countly.init();
    }
  }

  public startService(url: string, appKey: string): void {
    if (this.Countly !== undefined) {
      this.Countly.url = url;
      this.Countly.app_key = appKey;
      this.Countly.q = this.defaultTrackings;
    }
  }

  public debug(flag: boolean) {
    this.Countly.debug = flag;
  }

  public addTracking(key: string, value?: any) {
    if (this.Countly !== undefined) {
      if (!value) {
        this.Countly.q.push([key]);
      } else {
        this.Countly.q.push([key, value]);
      }
    }
  }

  public addTrackingPage(page: string) {
    if (this.Countly !== undefined) {
      this.Countly.q.push(['track_pageview', page]);
    }
  }

  public changeId(countryCode: string, newId: string) {
    if (this.Countly !== undefined) {
      this.Countly.q.push(['change_id', countryCode + newId]);
    }
  }

  public identifyUser(userfields: any) {
    if (this.Countly !== undefined) {
      this.Countly.q.push(['user_details', userfields]);
    }
  }

  public endSession() {
    if (this.Countly !== undefined) {
      this.Countly.q.push(['end_session']);
    }
  }

  public removeTracking(trackingjson: any) {
    if (this.Countly !== undefined) {
      this.Countly.q.forEach((element) => {
        if (element.indexOf(trackingjson) !== -1) {
          element[0] = 'canceled';
        }
      });
    }
  }

  public addGTM(applicationName?: string, pageTitle?: string, customerId?: string): void {
    if (!this.googleDataLayer) {
      return;
    }

    let currentUserCategory = PLACEHOLDER;
    let currentUserRole = PLACEHOLDER;
    let currentCustomerId = PLACEHOLDER;
    let currentCountry = PLACEHOLDER;
    let currentUserId = PLACEHOLDER;

    const ss = this.sessionService;

    if (ss.isLoggedIn) {
      currentUserCategory = ss.profile && ss.profile.isDigitalAdmin ? 'DA' : 'General';
      currentUserRole = ss.role === 'C' ? 'Customer' : 'Internal';
      currentCustomerId =
        customerId || (ss.currentLegalEntityValue && ss.currentLegalEntityValue.legalEntityTypeCode) || PLACEHOLDER;
      currentCountry = ss.country || PLACEHOLDER;
      currentUserId = (ss.profile && ss.profile.userId && ss.profile.userId.toString()) || PLACEHOLDER;
    }

    const marketingData = {
      application: applicationName || window.location.pathname.split('/')[1],
      countryCode: currentCountry,
      customerId: currentCustomerId,
      event: 'Pageview',
      pagePath: window.location.pathname,
      pageTitle: pageTitle || document.title.replace(' ', '_'),
      userCategory: currentUserCategory,
      userId: currentUserId,
      userSegment: ss.userSegment || PLACEHOLDER,
      userSubsegment: ss.userSubsegment || PLACEHOLDER,
      userType: currentUserRole,
    };

    this.googleDataLayer.push(marketingData);
  }

  public addGTMCustomerChange(newLegalEntityCode?: string): void {
    if (!this.googleDataLayer) {
      return;
    }

    const legalEntity = this.sessionService.currentLegalEntityValue;
    const legalEntityTypeCode = legalEntity && legalEntity.legalEntityTypeCode;
    const event = {
      event: 'customerChange',
      eventAction: 'Customer change',
      eventCategory: 'User interaction',
      eventLabel: newLegalEntityCode || legalEntityTypeCode || PLACEHOLDER,
    };

    this.googleDataLayer.push(event);
  }

  public addBulkVariables(request: any): void {
    if (this.googleDataLayer) {
      this.googleDataLayer.push(request);
    }
  }
}
